import type { SideState } from './_state.type';

/** Side State. */
export const sideState: SideState = {
  side: {
    states: {},
  },
};
